import { useLocation } from 'react-router-dom';

export function useQueryParams() {
  const { search } = useLocation();

  return new URLSearchParams(search);
}

export const getReferringRPId = (query: URLSearchParams): string => {
  const rpidSnakeCaseQuery = query.get('rp_id');
  if (rpidSnakeCaseQuery) {
    return rpidSnakeCaseQuery;
  }
  const referral_partner = query.get('referral_partner');
  if (referral_partner) {
    return referral_partner;
  }
  const rpIdQuery = query.get('rpId');
  if (rpIdQuery) {
    return rpIdQuery;
  }
  const rpidQuery = query.get('rpid');
  if (rpidQuery) {
    return rpidQuery;
  }
  const salesforceRpIdQuery = query.get('RP_ID__c');
  if (salesforceRpIdQuery) {
    return salesforceRpIdQuery;
  }
  return '';
};

export function useGetReferringRPId() {
  const params = useQueryParams();
  return getReferringRPId(params);
}

export function useGetUtmSource() {
  const params = useQueryParams();
  return params.get('utm_source') || '';
}

export function useGetSource() {
  const params = useQueryParams();
  return params.get('source') || '';
}

export function useGetTrackingEventData() {
  const rpId = useGetReferringRPId().trim();
  const utmSource = useGetUtmSource().trim();
  const source = useGetSource().trim();
  return { rpId, utmSource, source };
}

export function useGetPrefillData<T extends string>(
  paramKeys: readonly T[],
): Record<T, string | null> {
  const params = useQueryParams();
  const result = {} as Record<T, string | null>;

  for (const key of paramKeys) {
    result[key] = params.get(key);
  }

  return result;
}
